import { Users, Megaphone, Settings, CalendarDays, Briefcase } from 'lucide-react'
import { PersonaSummary } from './types'

// Cross-persona truths - messages that resonate with ALL personas
export const CROSS_PERSONA_TRUTHS = {
  fears: [
    'Making a bad visible decision',
    'Wasting time',
    'Losing control',
  ],
  wants: [
    'Clarity before commitment',
    'Guidance',
    'Accountability',
  ],
  messages: [
    'We guide you',
    'Nothing moves without approval',
    'One place for everything',
  ],
} as const

// Shared PERSONAS array for PersonasSection on Home page
export const PERSONAS: PersonaSummary[] = [
  {
    id: 'hr',
    slug: 'hr',
    label: 'Human Resources || HR',
    icon: Users,
    title: 'Make employees feel welcomed and valued || Få anställda att känna sig välkomna och uppskattade',
    description:
      'Streamline onboarding, anniversaries, and culture initiatives without the admin headache. || Effektivisera onboarding, jubileum och kulturinitiativ utan administrativ huvudvärk.',
  },
  {
    id: 'marketing',
    slug: 'marketing',
    label: 'Marketing & Brand || Marknadsföring & Varumärke',
    icon: Megaphone,
    title: 'Create merch that reinforces the brand || Skapa merch som förstärker varumärket',
    description:
      'Launch campaigns and events with quality branded merchandise that actually impresses. || Lansera kampanjer och event med kvalitativ varumärkesmerch som verkligen imponerar.',
  },
  {
    id: 'operations',
    slug: 'operations',
    label: 'Operations || Operations',
    icon: Settings,
    title: 'Make procurement predictable and controlled || Gör inköp förutsägbara och kontrollerade',
    description:
      'One supplier, clear approval flows, and no messy invoices or vendor chaos. || En leverantör, tydliga godkännandeflöden och inga röriga fakturor eller leverantörskaos.',
  },
  {
    id: 'events',
    slug: 'events',
    label: 'Event Managers || Eventansvariga',
    icon: CalendarDays,
    title: 'Get the right merch to the right place, on time || Få rätt merch till rätt plats, i tid',
    description:
      'Deadlines, venue logistics, and last-minute changes handled with confidence. || Deadlines, platslogistik och sista-minuten-ändringar hanteras med självförtroende.',
  },
  {
    id: 'founders',
    slug: 'founders',
    label: 'Founders & CEOs || Grundare & VD:ar',
    icon: Briefcase,
    title: 'Does this make us look good and scale? || Får detta oss att se bra ut och skala?',
    description:
      'Simplicity, strong brand signal, and one supplier that grows with you. || Enkelhet, stark varumärkessignal och en leverantör som växer med dig.',
  },
]
